export default {
  init() {
    // JavaScript to be fired on all pages
    const $linkPanel = $('.header__link-panel');
    const $footer = $('.footer');
    const $main = $('.main');
    const $header = $('#header');
    const $mainMenu = $('#main-menu');
    const $slideOut = $('.slide-out');
    const $overlay = $('.overlay');
    const $hamburger = $('.header__link-panel');

    const _stickyHeader = () => {
      $(window).scroll(function () {
        if ($(document).scrollTop() > 15) { // check if user scrolled more than 15 from top of the browser window
          $header.addClass('header--active');
          $mainMenu.addClass('main-menu--is-sticky');
          $slideOut.addClass('slide-out--scrolled');
          $hamburger.addClass('header__link-panel--scrolled');
        } else {
          $header.removeClass('header--active');
          $mainMenu.removeClass('main-menu--is-sticky');
          $slideOut.removeClass('slide-out--scrolled');
          $hamburger.removeClass('header__link-panel--scrolled');
        }
      })
    };

    const _menuMobile = () => {
      $linkPanel.on('click', function () {
        $slideOut.toggleClass('slide-out--open');
        $(this).toggleClass('active');
        $overlay.toggleClass('overlay--active');
        $('.header .calculator-icon').toggleClass('d-none');
      });

      $(document).on('click', function(event) {
        console.log(event.target)
        if ((!$(event.target).closest($linkPanel).length) && (!$(event.target).closest($slideOut).length)) {
          $slideOut.removeClass('slide-out--open');
          $linkPanel.removeClass('active');
          $overlay.removeClass('overlay--active');
          $('.header .calculator-icon').removeClass('d-none');
        }
      });
    };

    const _opentab = () => {
      $('ul.tabs li').click(function(){
        var tab_id = $(this).attr('data-tab');
        $('ul.tabs li').removeClass('current');
        $('.tab-content').removeClass('current');
        $(this).addClass('current');
        $('#'+tab_id).addClass('current');
        $('.list-tabs__content').slideUp();

      }),
      $('.list-tabs .list-tabs__title').click(function() {
        var currentTabContent = $(this).parent().find('.list-tabs__content');
        $('.list-tabs__content').not(currentTabContent).slideUp();
        currentTabContent.slideToggle();
      }),
      $('.heading-mobile').click(function(){
        var cat_name = $(this).attr('data-name');
        $('.heading-mobile').not(this).removeClass('open');
        $(this).toggleClass('open');
        $('#tabs .tab-content').removeClass('current');

        var currentTabContent = $('#tabs .'+cat_name);
        $('#tabs .tab-content').not(currentTabContent).slideUp(400);
        currentTabContent.slideToggle(400);
      });
    };

    const _openPopup = () => {
      $('#header .calculator-icon').click(function(){
        $('.pop-up').addClass('popup-open');
        $('.pop-up .block-calculator').find('.calculator-icon').addClass('calculator-close');
        $('.block-calculator__content').show('d-flex');//new
        $('body').addClass('modal-cal');
      });
      $('.pop-up .calculator-icon').click(function(){
        $('.pop-up.calculator').removeClass('popup-open');
        $('body').removeClass('modal-cal');
        $(this).closest('.pop-up').find('.block-calculator').trigger('reset');
      });
      $(document).on('click', '.pop-up', function() {
        if (!$(event.target).closest('.block-calculator').length && !$(event.target).is('.block-calculator')) {
          $('.pop-up').removeClass('popup-open');
          $('body').removeClass('modal-cal');
          $(this).find('.block-calculator').trigger('reset');
        }
      });
    };

    const _opencalculator = () => {
      $('.c-desk .calculator-icon').click(function(){
        $('.c-desk').toggleClass('open');
        if ($(this).hasClass('calculator-close')) {
          $(this).closest('.block-calculator').trigger('reset');
        }
        $(this).toggleClass('calculator-close');
        $('.block-calculator__content').toggleClass('d-flex');
      });
      $('.c-desk .block-calculator__title').click(function(){
        $(this).parent().toggleClass('open');
        $('.c-desk .calculator-icon').toggleClass('calculator-close');
        $('.block-calculator__content').toggleClass('d-flex');
      })
    };

    const _openlocation = () => {
      $('.views-mobile').click(function(){
        var $content = $(this).find('.box-hidden');
        $('.box-hidden').not($content).slideUp(400);
        $('.views-mobile').not(this).removeClass('open');
        $(this).toggleClass('open')
        $content.slideToggle(400);
      })
    }

    const _activeStepApp = () => {
      if ($('.application-header__step .nav-item.active').length) {
        $('.application-header__step .nav-item.active').prevAll().each(function () {
          $(this).addClass('passed');
          $(this).find('.nav-link').addClass('passed');
        })
      }
    }

    const _footerbottom = () => {
      var h = $(window).outerHeight() - ($footer.height() + $header.height());
      $main.css('min-height', h);
    }

    const _selectCategory = () => {
      const $select = $('select#categorieen-posts');
      let initTimeout;

      if ($select.length) {
        $(window).on('resize.select2', function () {
          clearTimeout(initTimeout);

          initTimeout = setTimeout(function () {
            $select.select2({
              minimumResultsForSearch: Infinity,
              width: '100%',
            });
          }, 200);
        }).trigger('resize.select2');
      }
    }

    const _bindEvents = () => {
      $('.search-home').submit(function(){
        $('.search-home .txt-input').removeClass('inputError');
        var hasError = false;
        $('.search-home .requiredField').each(function() {
          if($.trim($(this).val()) == '') {
            $(this).addClass('inputError');
            hasError = true;
          }
        });
        if(!hasError){
          return true;
        }
        return false;
      })
      $('.search-map').submit(function(){
        $('.search-map .txt-input').removeClass('inputError');
        var hasError = false;
        $('.search-map .requiredField').each(function() {
          if($.trim($(this).val()) == '') {
            $(this).addClass('inputError');
            hasError = true;
          }
        });
        if(!hasError){
          return true;
        }
        return false;
      })
    }

    _menuMobile();
    _opentab();
    _opencalculator();
    _openPopup();
    _openlocation();
    _activeStepApp();
    _footerbottom();
    _selectCategory();
    _bindEvents();
    _stickyHeader();

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/common.js